export default __webpack_public_path__ + "static/media/common.0208e1fc.png";